import Styles from './NotificationItem.module.scss'
import { NotificationDesign as NotificationDesignType } from './types'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Text } from 'blaze-ui/Text/Text'
import { DesignEmoji } from 'components/CopyModal/components/CopyTitleInput/components/DesignEmoji'
import { Design } from 'blaze-ui/icons'

interface Props {
  design: NotificationDesignType
}

export const NotificationDesign = ({ design }: Props) => {
  return (
    <div className={Styles.file}>
      {design?.channel ? (
        <div className={Styles.emoji}>
          <ChannelIcon channel={design.channel} defaultIcon={Design} />
        </div>
      ) : (
        <DesignEmoji emoji={design.emoji || null} />
      )}
      <Text lineClamp={1} variant="placeholder" color="var(--dark-80)">
        {design.title}
      </Text>
    </div>
  )
}
